import { Module, ActionContext } from 'vuex';
import { ajax } from '@/util/ajax';

const URL = {
  KNOWLEDGE_GRAPH_PAGE: '/dh-datamaint/knowledgeGraph/page',
  KNOWLEDGE_GRAPH_ADD: '/dh-datamaint/knowledgeGraph/add',
  KNOWLEDGE_GRAPH_DELETE: '/dh-datamaint/knowledgeGraph/delete',
  KNOWLEDGE_GRAPH_DETAIL: '/dh-datamaint/knowledgeGraph/detail',
  KNOWLEDGE_GRAPH_UPDATE: '/dh-datamaint/knowledgeGraph/update',
  KNOWLEDGE_GRAPH_SORT: '/dh-datamaint/knowledgeGraph/sort',
};

class KnowledgeGraphModule implements Module<any, any> {
  namespaced = true;

  state = {};

  mutations = {};

  actions = {
    async getPage(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.KNOWLEDGE_GRAPH_PAGE, { params: payload.data });
    },

    async getDetail(context: ActionContext<any, any>, payload: any) {
      return await ajax.get(URL.KNOWLEDGE_GRAPH_DETAIL, { params: payload.data });
    },

    async Add(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.KNOWLEDGE_GRAPH_ADD, payload.data);
    },

    async Update(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.KNOWLEDGE_GRAPH_UPDATE, payload.data);
    },

    async Delete(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.KNOWLEDGE_GRAPH_DELETE, null, { params: payload.data });
    },

    async Sort(context: ActionContext<any, any>, payload: any) {
      return await ajax.post(URL.KNOWLEDGE_GRAPH_SORT, payload.data);
    },
  };
}

export const knowledgeGraphModule = new KnowledgeGraphModule();
